export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Sewing & Pattern Making Instructor Atlas after purchasing?',
    a: ['You receive instant digital access to the materials after your payment is successfully completed.'],
  },
  {
    q: 'What format is it in?',
    a: [
      'All materials are delivered as PDF files. You can print them as handouts or show them on a tablet, screen or projector in your classroom, sewing studio or workshop.',
    ],
  },
  {
    q: 'Who is it for?',
    a: [
      'It is designed for sewing instructors, pattern-making teachers, sewing academies and studios, fashion and apparel teachers, community and vocational sewing programs, and tailors or dressmakers who teach. Adjust the content to your students, your level and your own curriculum.',
    ],
  },
  {
    q: 'What levels does it cover?',
    a: [
      'From beginner to advanced. Training pages include Easy, Standard and Advanced variants, so you can match each class to your students.',
    ],
  },
  {
    q: 'Does it work for beginner classes and advanced courses?',
    a: [
      'Yes. The material covers sewing fundamentals, fabrics and machine techniques, body measurements and pattern drafting, draping and fitting, garment construction, tailoring, finishing and alterations, and sewing teaching methods, so it works for beginner classes, garment construction courses, pattern-making courses and short workshops alike.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six volumes contain 300 visual training pages (50 per volume). Each page includes an illustration or labeled diagram, a step-by-step breakdown when it applies, a ❌ common mistake vs. ✅ correct technique comparison, a teaching cue, a drill and a quick check. The five bonuses add practical teaching tools.',
    ],
  },
  {
    q: 'Does it include ready-to-teach lessons?',
    a: [
      'Yes. The system is built around a simple method — OPEN → CHOOSE → SHOW → TEACH — with lesson plans, demonstration guides, project banks, drills and quick checks you can use right away.',
    ],
  },
  {
    q: 'What topics does it cover?',
    a: [
      'Sewing fundamentals, tools, fabrics and machine techniques; pattern making, body measurements and garment drafting; advanced pattern making, draping and garment fitting; garment cutting, assembly and construction techniques; professional tailoring, finishing techniques and garment alterations; and sewing instruction, teaching programs and practical assessments.',
    ],
  },
  {
    q: 'Does it use inches or centimeters?',
    a: ['Both. Seam allowances and key measurements are shown in inches and centimeters, for example 5/8 in (1.5 cm).'],
  },
  {
    q: 'Does it replace an accredited fashion or sewing curriculum?',
    a: [
      'No. This is educational teaching-support material for instructors. It does not replace an accredited fashion, apparel or sewing curriculum, official certifications, your sewing machine’s manufacturer manual, workplace safety rules or qualified professional supervision. Always follow your institution’s and your studio’s safety rules, especially when using machines, irons, steam and cutting tools.',
      'Results depend on each instructor, student and learning context, so no specific results are guaranteed.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete package includes all six visual sewing, pattern making and garment construction volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. The five listed bonuses are included with the complete package at no additional cost under this offer.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. This is a digital educational resource package containing PDF materials. Videos are not included.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The materials are written in English for an international audience.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided as PDFs, not editable source files.'],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The listed package is offered as a one-time payment, with no subscription.'],
  },
]
